import {useFormik} from 'formik';
import {useSchemes} from '../../../shared';
import {useState} from 'react';
import {CreateBenefactorDTO, useBenefactors} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseAddBenefactorFormProps = {
  setOpen: (open: boolean) => void;
};

export const useAddBenefactorForm = ({setOpen}: UseAddBenefactorFormProps) => {
  const {displayNameSchema, displayNameNotRequiredSchema} = useSchemes();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {createBenefactorMutation} = useBenefactors();

  const onSubmit = async (values: CreateBenefactorDTO) => {
    setErrorMessage(null);
    try {
      await createBenefactorMutation.mutateAsync(values);
      setOpen(false);
    } catch (error: any) {
      if (error instanceof AxiosError) {
        setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при создании пользователя');
      } else {
        setErrorMessage('Произошла ошибка при создании пользователя');
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      displayName: '',
      realName: '',
    },
    validationSchema: Yup.object({
      displayName: displayNameNotRequiredSchema,
      realName: displayNameSchema,
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: createBenefactorMutation.isPending,
    submitError: createBenefactorMutation.error ? (createBenefactorMutation.error as AxiosError<ApiError>).response?.data : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
}; 